export const CHECKOUT_STEPS = [
  'Meal Prep',
  'Recipes',
  'Extras',
  'Secure Checkout',
];
